module.exports = __webpack_public_path__ + "img/3.9c92be04.png";